// extracted by mini-css-extract-plugin
module.exports = {"App":"App--2QCMZ","waiting":"waiting--ilgKB"};